import {Component} from '@angular/core';
import {MsalService} from '@azure/msal-angular';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-access-restricted',
  templateUrl: './access-restricted.component.html',
  styleUrls: ['./access-restricted.component.scss']
})
export class AccessRestrictedComponent {
  supportEmailAddress = environment.supportEmailAddress;

  constructor(private msalAuthService: MsalService) {
  }

  logout() {
    this.msalAuthService.logoutRedirect({
      postLogoutRedirectUri: window.location.origin
    });
  }
}
